import React from 'react';
import {
  FDBodyText,
  FDBox,
  FDHeadlineText,
  FDStack,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';
import HouseholdInfoSectionFamilyMember from './HouseholdInfoSectionFamilyMember';

const HouseholdInfoSectionFamilyMembers = ({ collection }) => {
  function getFamilyMembers() {
    if (!collection?.resources()?.length() > 0) {
      return (
        <FDBodyText value={'No other family added'} />
      );
    }

    return collection.resources().list().map((resource) => (
      <FDBox key={resource.id()}>
        <HouseholdInfoSectionFamilyMember resource={resource} />
      </FDBox>
    ));
  }

  return (
    <FDBox>
      <FDHeadlineText value={'Family'} color={'textSecondary'} />
      <FDBox paddingY={2}>
        <FDStack spacing={2} direction={'column'}>
          {getFamilyMembers()}
        </FDStack>
      </FDBox>
    </FDBox>
  );
};

HouseholdInfoSectionFamilyMembers.propTypes = {
  collection: PropTypes.object.isRequired,
};

HouseholdInfoSectionFamilyMembers.defaultProps = {};

export default HouseholdInfoSectionFamilyMembers;
